var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-input-mask"},[_c('the-mask',_vm._g({staticClass:"input-control",attrs:{"value":_vm.value,"mask":_vm.mask,"masked":_vm.masked,"placeholder":_vm.placeholder}},_vm.$listeners)),(_vm.suffix)?_c('div',{staticClass:"suffix"},[_vm._v(_vm._s(_vm.suffix))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }